// extracted by mini-css-extract-plugin
export default {"layout":"BlankLayout_layout__bKKft"};